<button
  [id]="id + '27e2298c-f8c3-4bd5-8f80-5cc0687ce667'"
  (click)="selectPaymentMethod(paymentMethodType)"
  (focus)="onFocus($event)"
  [class.selected]="isSelected"
  class="hover:bg-n-10 hover:cursor-pointer pt-2 px-4 h-[105px] flex flex-col items-center justify-center border-r-[1px] border-n-20 text-center focus:bg-n-10 focus:outline-none focus-visible:outline-none"
  [matomoClickCategory]="MATOMO_EVENT_CATEGORY_PAYMENT"
  [matomoClickAction]="matomoEventClickAction"
  [matomoClickName]="paymentMethodType"
  *ngIf="paymentMethodType">
  <yat-icon [name]="paymentMethodType | addPaymentMethodTypeIcon: 'duo'"></yat-icon>
  <div
    [id]="id + '0750b9f8-318c-486d-b803-c149acc9ac6f'"
    class="flex text-n-40 mt-1 text-sm h-10 leading-base-sm place-content-center items-center select-none"
    [class.direct-debit]="paymentMethodType === 'DIRECT_DEBIT'">
    {{ paymentMethodType | paymentMethodTypeWording | async }}
  </div>
  <yat-icon id="81be6d1e-1a9c-451d-bf1d-dba988633452" *ngIf="isSelected" name="tick-circle-duo" class="tick-circle-duo"></yat-icon>
</button>
